import { VFooter } from 'vuetify/lib/components/VFooter';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.publicDashboardVersion ? _c('v-div', {
    staticStyle: {
      "line-height": "0.6"
    },
    attrs: {
      "id": "core-div",
      "height": "28",
      "absolute": ""
    }
  }, [_c('div', {
    staticClass: "footer-items mb-2"
  }, [_vm.imprintUrl ? _c('a', {
    staticClass: "tertiary--text footer-links ml-3",
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "href": _vm.imprintUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.drawer.imprint')) + "\n    ")]) : _vm._e(), _vm.aboutUsUrl ? _c('a', {
    staticClass: "tertiary--text footer-links ml-2",
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "href": _vm.aboutUsUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.drawer.dataProtection')) + "\n    ")]) : _vm._e()])]) : _c(VFooter, {
    style: _vm.loginPageVersion ? {
      background: '#ffffff',
      marginBottom: '0.5em'
    } : {
      marginBottom: '-3rem'
    },
    attrs: {
      "id": "core-footer",
      "height": "48",
      "absolute": ""
    }
  }, [_c('div', {
    staticClass: "footer-items"
  }, [_vm.imprintUrl ? _c('a', {
    staticClass: "tertiary--text footer-links",
    attrs: {
      "href": _vm.imprintUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.drawer.imprint')) + "\n    ")]) : _vm._e(), _vm.aboutUsUrl ? _c('a', {
    staticClass: "tertiary--text footer-links",
    attrs: {
      "href": _vm.aboutUsUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.drawer.aboutUs')) + "\n    ")]) : _vm._e(), _c('a', {
    staticClass: "tertiary--text footer-links",
    attrs: {
      "href": this.$store.state.app.docsBaseURL,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.version))]), _c('a', {
    staticClass: "tertiary--text footer-links",
    attrs: {
      "href": _vm.$i18n_t('Common.footerOssLicensesUrl'),
      "target": "_blank"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.footerOssLicenses')) + "\n    ")])]), !_vm.responsive ? _c(VSpacer) : _vm._e(), !_vm.responsive && _vm.copyrightText ? _c('span', {
    staticClass: "copyright"
  }, [_vm._v("\n    ©\n    " + _vm._s(new Date().getFullYear()) + "\n    "), _vm.copyrightUrl ? _c('a', {
    attrs: {
      "href": _vm.copyrightUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.copyrightText))]) : _c('span', [_vm._v(_vm._s(_vm.copyrightText))])]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };